import { useState } from "react";
import Button from "components/button";
import LoaderButton from "components/button/LoaderButton";
import Modal from "components/modal";
import { useDispatch, useSelector } from "react-redux";
import { deleteOrderItem } from "store/orderSlice";
import { FaTrashAlt } from "react-icons/fa";

const DeleteItemModal = ({ data, refreshList }) => {
  const dispatch = useDispatch();
  const { deleteOrderItemError, deleteOrderItemLoading } = useSelector(
    (state) => state.orders
  );

  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleDelete = async () => {
    try {
      await dispatch(deleteOrderItem(data)).unwrap();
      refreshList();
      closeModal();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <>
      {/* Trigger button */}
      <Button type="button" variant="" onClick={openModal}>
        <FaTrashAlt className="h-4 w-4" />
      </Button>

      {/* Modal */}
      <Modal isOpen={isOpen} onClose={closeModal} className="max-w-lg">
        <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
          Delete Items
        </h2>

        <div className="relative w-full rounded-3xl p-4 lg:p-5">
          <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
            Are you sure you want to delete this item?
          </p>

          <div className="flex flex-col">
            {deleteOrderItemError && (
              <div className="mt-2 grid grid-cols-1 gap-5">
                <p className="text-sm text-red-500">{deleteOrderItemError}</p>
              </div>
            )}

            <div className="mt-6 flex items-center justify-end gap-3">
              <Button type="button" variant="outline" onClick={closeModal}>
                Cancel
              </Button>

              <LoaderButton
                type="button"
                isLoading={deleteOrderItemLoading}
                onClick={handleDelete}
              >
                Delete Item
              </LoaderButton>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteItemModal;
